import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Paper from "@mui/material/Paper";
import { DataGrid } from "@mui/x-data-grid";
import { Card, CardContent, Typography, Divider } from "@mui/material";

import { isoTimestampToLocal } from "../utils/timeStampConversion.js";
import { convertToCommaNumbers } from "../utils/inputSanitation.js";
import { usePaymentsContext } from "../../contexts/PaymentsContextProvider";

const RechargeHistory = () => {
  const { getRechargeHistory } = usePaymentsContext();
  const [rechargeHistory, setRechargeHistory] = useState({});

  const rechargeHistoryTableColumns = [
    {
      field: "refId",
      headerName: "Order Id",
      width: 200,
      sortable: true,
      valueGetter: (value, row) => row?.refId,
    },
    {
      field: "recharge_amount",
      headerName: "Recharge Amount",
      width: 200,
      sortable: true,
      valueGetter: (value, row) =>
        row?.amount ? convertToCommaNumbers(row?.amount) : "-",
    },
    {
      field: "recharge_gst",
      headerName: "GST Amount",
      width: 200,
      sortable: true,
      valueGetter: (value, row) =>
        row?.recharge_gst ? convertToCommaNumbers(row?.recharge_gst) : "-",
    },
    {
      field: "recharge_currency",
      headerName: "Recharge Currency",
      width: 200,
      sortable: true,
      valueGetter: (value, row) => row?.currency,
    },
    {
      field: "coins_purchased",
      headerName: "Coins Purchased",
      width: 200,
      sortable: true,
      valueGetter: (value, row) => convertToCommaNumbers(row?.coins_purchased),
    },
    {
      field: "recharge_date",
      headerName: "Recharge Date",
      width: 200,
      sortable: true,
      valueGetter: (value, row) => isoTimestampToLocal(row?.recharge_date),
    },
    {
      field: "coins_expiry_date",
      headerName: "Expiry Date",
      width: 200,
      sortable: true,
      valueGetter: (value, row) => isoTimestampToLocal(row?.coins_expiry_date),
    },
  ];

  const callRechargeHistory = async () => {
    const response = await getRechargeHistory();
    // console.log("callRechargeHistory response", response);

    if (response?.Error) {
      toast.error(response?.Error);
    } else {
      setRechargeHistory(response?.result);
    }
  };

  useEffect(() => {
    callRechargeHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full mt-5 mb-10 lg:my-1 space-y-8">
      <div className="w-full space-y-2">
        <h1 className="text-2xl">Recharge History</h1>
        <h3>These are details about all your current and past recharge.</h3>
      </div>

      <Card className="shadow-md rounded-2xl">
        <CardContent className="space-y-3">
          <Typography variant="h6" className="font-bold mb-2">
            Coin Tracker
          </Typography>

          <div className="grid grid-cols-2 gap-5 py-1">
            <span className="font-bold">
              Coins Deduction / Outgoing conversation
            </span>
            <span className="text-red-600">
              {rechargeHistory?.coin_tracker?.coins_deduct_per_outgoing_conv}{" "}
              coins
            </span>
          </div>
          <Divider />

          <div className="grid grid-cols-2 gap-5 py-1">
            <span className="font-bold">
              Coins Deduction / Incoming conversation
            </span>
            <span className="text-red-600">
              {rechargeHistory?.coin_tracker?.coins_deduct_per_incoming_conv}{" "}
              coins
            </span>
          </div>
          <Divider />

          <div className="grid grid-cols-2 gap-5 py-1">
            <span className="font-bold">Total spent coins</span>
            <span>
              {convertToCommaNumbers(
                rechargeHistory?.coin_tracker?.total_coins_spent
              )}
            </span>
          </div>
          <Divider />

          <div className="grid grid-cols-2 gap-5 py-1">
            <span className="font-bold">Total purchased coins</span>
            <span>
              {convertToCommaNumbers(
                rechargeHistory?.coin_tracker?.total_coins_purchased
              )}
            </span>
          </div>
          <Divider />

          <div className="grid grid-cols-2 gap-5 py-1">
            <span className="font-bold">Total expired coins</span>
            <span>
              {convertToCommaNumbers(
                rechargeHistory?.coin_tracker?.num_of_coins_expired
              )}
            </span>
          </div>
          <Divider />

          <div className="grid grid-cols-2 gap-5 py-1">
            <span className="font-bold">Last purchased coins</span>
            <span>
              {convertToCommaNumbers(
                rechargeHistory?.coin_tracker?.num_of_coins_last_purchased
              )}
            </span>
          </div>
        </CardContent>
      </Card>

      <div className="mt-10 space-y-3 rounded-md">
        <h3 className="font-Montserrat text-lg">Recharge History</h3>
        <Paper style={{ position: "relative", height: 550, zIndex: 1 }}>
          <DataGrid
            getRowId={(row) => row?.id}
            rows={rechargeHistory?.recharge_history || []}
            columns={rechargeHistoryTableColumns}
            sx={{
              border: 0,
              "& .MuiDataGrid-columnHeaders": {
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "background.paper",
              },
              "& .MuiDataGrid-virtualScroller": {
                marginTop: "0px",
              },
            }}
            disableColumnMenu={false}
            disableRowSelectionOnClick={true}
          />
        </Paper>
      </div>
    </main>
  );
};
export default RechargeHistory;
